import * as React from 'react';
import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import * as ReactDOMServer from 'react-dom/server';
import { MapPin } from '../../../components/MapPin';
import { TMapItemType } from '../../../types/map';
import { IMainPromoPin } from '../../../types/newbuilding/mainPromoPin';
import { getPinSize } from './getPinSize';

interface IGetGeoObjectOptions {
  name: TMapItemType;
  coordinates: IMapCoordinates;
  id: string;
  mainPromoPin?: IMainPromoPin | null;
}

export const getGeoObject = ({ name, coordinates, id, mainPromoPin }: IGetGeoObjectOptions): IMapGeoObject => {
  const size = getPinSize({ name, mainPromoPin });

  return {
    type: 'Point',
    name,
    options: {
      coordinates,
      html: ReactDOMServer.renderToStaticMarkup(<MapPin type={name} mainPromoPin={mainPromoPin} />),
      id,
      width: size,
      height: size,
    },
  };
};

type TCoordinates = [number, number] | number[];

interface IGetPolygonGeoObjectOptions {
  name: TMapItemType;
  coordinates: TCoordinates[];
  id: string;
}

export const getPolygonGeoObject = ({ name, coordinates, id }: IGetPolygonGeoObjectOptions): IMapGeoObject => {
  return {
    type: 'Polygon',
    name,
    options: {
      coordinates: [coordinates],
      id,
    },
  };
};
